import type { CSSProperties } from "react";

export const INPUT_STYLE: CSSProperties = {
	height: 36,
	padding: "0 10px",
	fontSize: "var(--text-ui)",
	color: "var(--fg-1)",
	background: "var(--surface-1)",
	border: "none",
	borderRadius: "var(--radius-3)",
	boxShadow: "var(--shadow-ring)",
	outline: "none",
	fontFamily: "var(--font-sans)",
	transition: "box-shadow 150ms ease",
	width: "100%",
	boxSizing: "border-box",
};

export function focusRingOn(el: HTMLElement): void {
	el.style.boxShadow = "var(--shadow-focus)";
}

export function focusRingOff(el: HTMLElement): void {
	el.style.boxShadow = "var(--shadow-ring)";
}
